export enum GlobalNotificationTypes {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning'
}
